import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory, useRouteMatch } from "react-router-dom";
import { logDoctorVisit } from "../../store/features/slice-doctors";
import parse from 'html-react-parser';
import { setPageClass, setUpHeader } from "../../store/features/slice-ui";
import PageHead from "../../components/PageHead";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import { Word } from "../../components/Word";
import SingleProfile from "../../components/Dcotor/SingleProfile"
import SingleLocations from "../../components/Dcotor/SingleLocations"
import SingleContact from "../../components/Dcotor/SingleContact"
import CenterCard from "../../components/Cards/Contact"; 
import DoctorCard from "../../components/Cards/Cta";
import Button from "../../components/Button"; 
import Tabs from "../../components/Tabs";


const DoctorDetails_RP = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const match = useRouteMatch();
    let { centreSlug } = useParams();
    let { doctorSlug } = useParams();
    const doctorDetailsSingle = useSelector((state) => state.doctors.full ? state.doctors.full[doctorSlug] : null);
    const centresListBasic = useSelector((state) => state.centres.basic);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const accountData = useSelector((state) => state.account.data);

    const [tabIndex, setTabIndex] = useState(0);
    useEffect(() => {
        dispatch(setPageClass("page-referpatient-singledoctor"));
        dispatch(setUpHeader({
            show: true,
            back: true,
            profile: true,
            search: true
        }));
    }, [dispatch]);

    useEffect(() => {
        if(centreSlug){
            //Check if centre exists
            if(centresListBasic && Object.keys(centresListBasic).length > 0 && !centresListBasic[centreSlug]){
                history.replace('/refer-patient/centre');
            }
            else{
                //check if Dr belong to centre
                if(centresListBasic && Object.keys(centresListBasic).length > 0 && centresListBasic[centreSlug]){
                    if(doctorDetailsSingle){
                        if(!doctorDetailsSingle.centres.find(item => item.slug === centreSlug)){
                            history.replace('/refer-patient/centre');
                        }
                    }
                }
            }
        }
      }, [centresListBasic, history, centreSlug, doctorDetailsSingle]);

    useEffect(() => {
        if(isAuthenticated && doctorDetailsSingle){
            dispatch(logDoctorVisit({slug: doctorDetailsSingle.slug}))
        }
    }, [dispatch, isAuthenticated, doctorDetailsSingle]);

    const handleTabClick = (i) => {
        setTabIndex(i);
    }

    return (

        <>
            {doctorDetailsSingle ?
                <>
                    <PageHead
                        className="page-referpatient-singledoctor--page-head"
                        title="Refer a Patient"
                    />
                    <PageContent className="page-referpatient-singledoctor--page-content">
                        <Section className="split-content w-40-60">
                            <Section className="page-referpatient-singledoctor--selection">
                                <div className="page-referpatient-singledoctor--selection-content">
                                    {centresListBasic && Object.keys(centresListBasic).length > 0 && centresListBasic[centreSlug] ? 
                                        <div className="page-referpatient-singledoctor--selection-centre">
                                            <h3><Word value="Centre" /></h3>
                                            <CenterCard
                                                image={centresListBasic[centreSlug].image}
                                                title={centresListBasic[centreSlug].title}
                                                minimal
                                            />
                                        </div>
                                    : null }
                                    <div className="page-referpatient-singledoctor--selection-specialist">
                                        <h3><Word value="Specialist" /></h3>
                                        <DoctorCard
                                            image={doctorDetailsSingle.profileImage && doctorDetailsSingle.profileImage.length > 0 ? doctorDetailsSingle.profileImage[0] : null}
                                            title={parse(doctorDetailsSingle.salutation+" "+doctorDetailsSingle.name)}
                                            subtitle={doctorDetailsSingle.tags && doctorDetailsSingle.tags.length > 0 ? doctorDetailsSingle.tags.map((tag, index) => index > 0 ? ', '+tag.name : tag.name)  : null}
                                            isCentered
                                            isFavourite = {accountData && accountData.favourites.includes(doctorDetailsSingle.slug) ? true : false}
                                            // icon="chevron_right"
                                            // link={`${match.url}/${id}`}
                                        />
                                    </div>
                                </div>
                            </Section>
                            <Section className="page-referpatient-singledoctor--content">
                                <Section className="">
                                    <Tabs className="page-referpatient-singledoctor--tabs-btns"
                                        items={[
                                        {
                                            index: 0,
                                            text: 'Profile', 
                                            Clicked:() => handleTabClick(0)
                                        }, 
                                        {
                                            index: 1,
                                            text: 'Location', 
                                            Clicked:() => handleTabClick(1)
                                        },
                                        {
                                            index: 2,
                                            text: 'Contact', 
                                            Clicked:() => handleTabClick(2)
                                        }
                                        ]}
                                        activeItem={tabIndex}
                                    />
                                    <div className="page-doctor-single--tabs-content">
                                        {tabIndex === 0 ? 
                                            <SingleProfile 
                                                slug={doctorDetailsSingle.slug}
                                                interests={doctorDetailsSingle.interests}
                                                interestsText={doctorDetailsSingle.interestsText}
                                                publications={doctorDetailsSingle.publications}
                                                bio={doctorDetailsSingle.bio}
                                            />
                                        :  null}
                                        {tabIndex === 1 ? 
                                            <SingleLocations 
                                                centres={doctorDetailsSingle.centres}
                                            />
                                        : null}
                                        {tabIndex === 2 ? 
                                            <SingleContact 
                                                foxoId={doctorDetailsSingle.foxoId}
                                                linkedinUrl={doctorDetailsSingle.linkedinUrl}
                                                phone={doctorDetailsSingle.phone}
                                                phoneFormatted={doctorDetailsSingle.phoneFormatted}
                                                fax={doctorDetailsSingle.fax}
                                            />
                                        : null}
                                    </div>
                                </Section>
                            </Section>
                        </Section>
                        <Section className="page-referpatient-singledoctor--actions">
                            <div className="page-referpatient-singledoctor--actions-start">
                                <Button 
                                    className="btn-primary text-yellow full-width"
                                    text="Proceed with referral"
                                    Clicked={() => history.push(`${match.url}/proceed`)}
                                />
                            </div>
                        </Section>
                    </PageContent>
                </>
                : null}
        </>
    );
};

export default DoctorDetails_RP;
